import { IQuestion } from '@ebb-v2/ebb-integration';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { cloneDeep } from '@apollo/client/utilities/common/cloneDeep';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  constructor(private _fb: FormBuilder) { }

  public questionSort(_questions: IQuestion[]): IQuestion[][] {
    const mappedQuestions: IQuestion[][] = [];
     let questions =cloneDeep(_questions) ;
    // Sort all questions, first by questionSet
    questions.sort((a, b) =>
      a.questionSet > b.questionSet
      ? 1
      : b.questionSet > a.questionSet
      ? -1
      : 0
    );

    //reset the question set numbers because gaps can cause errors
    //get the unqiue sets of questionSet numbers
    const questionSets = questions.map(item => item.questionSet).filter((value, index, self) => self.indexOf(value) === index);

    //foreach questionSet number loop thru questions
    //if match questionSet == question.questionSet
    //set question.questionSet equal to questionSet loop index
    //will fix a questionSet order of [1,2,4,5] to [1,2,3,4] not breaking the UI

    
 
    for(let i = 0; i < questionSets.length; i++)  {
      for(let k = 0; k < questions.length; k++)  {
        if(questions[k].questionSet === questionSets[i])  {
          
          questions[k].questionSet = i + 1;
        }
      }
    }

    let previousSetNumber = questions[0].questionSet;
    let previousSetQuestions: IQuestion[] = [];

    questions.forEach(question => {
      // If the question is of the "option set" type, format accordingly.
      if (question.inputTypeOptionSet && question.inputTypeOptionSet.toLowerCase() === 'select') {
        question.inputValues = this.trimarray(question.inputValue.split(','));
        question.inputValue = question.inputValues.join(",");
        var  qualifications = question.qualification.split(',');
        qualifications = this.trimarray(qualifications);
        question.qualification =qualifications.join(",");
      }

      if (question.questionSet !== previousSetNumber) {
        // Sort this set of questions by questionOrder
        previousSetQuestions.sort((a, b) =>
          a.questionOrder > b.questionOrder
          ? 1
          : b.questionOrder > a.questionOrder
          ? -1
          : 0
        );

        const setArr = [];
        mappedQuestions.push(setArr);
        previousSetQuestions.forEach(question => mappedQuestions[question.questionSet - 1].push(question));
        previousSetQuestions = [];
        previousSetNumber = question.questionSet;
      }
      
      previousSetQuestions.push(question);
    });

    // Sort last set of questions by questionOrder
    previousSetQuestions.sort((a, b) =>
      a.questionOrder > b.questionOrder
      ? 1
      : b.questionOrder > a.questionOrder
      ? -1
      : 0
    );

    const setArr = [];
    mappedQuestions.push(setArr);
    previousSetQuestions.forEach(question => mappedQuestions[question.questionSet - 1].push(question));

    return mappedQuestions;
  }
  public trimarray (stringarray :string[]){
    let array = [];
    stringarray.forEach(str=>{
      str = str.replace(/^\s+/, '');
      for (var i = str.length - 1; i >= 0; i--) {
          if (/\S/.test(str.charAt(i))) {
              str = str.substring(0, i + 1);
              break;
          }
      }
    array.push(str);});
  
  
    return array;
  }
  public trimstring (str) {
    str = str.replace(/^\s+/, '');
    for (var i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
            str = str.substring(0, i + 1);
            break;
        }
    }
    return str;
}
  public buildSetFormGroup(questionSet: IQuestion[]): FormGroup {
    const group = [];

    questionSet.forEach(question => {
      const controlName: string = question.name.split(/[\s-]+/).map(el => el.toLowerCase()).join('-');
      group[controlName] = new FormControl(question.inputSelectedValue, [
        Validators.required,
        ((control: AbstractControl) => {
          if (question.qualification.indexOf(',') > -1 && !question.qualification.split(',').includes(control.value)) {
            return { unqualified: true };
          } else if (question.qualification.indexOf(',') < 1 && control.value !== question.qualification) {
            return { unqualified: true };
          } else {
           return null;
          }
        })
      ]);

      //add in 'Other' textbox control for 'Source' select box
      if(question.name === 'Source') {
        const controlNameOther = controlName + 'Other';
        group[controlNameOther] = new FormControl(question.inputValueOther, []);
      }
    });

    return this._fb.group(group);
  }

  public buildQuestionnaire(...args: FormGroup[]): FormGroup {
    const formGroup = {};

    args.forEach((arg, index) => {
      const controlName = `set${index + 1}`;
      formGroup[controlName] = arg;
    });

    return this._fb.group(formGroup);
  }

  public buildFormConfig(questionData: IQuestion[][]): IQuestion[][] {
    questionData = questionData.filter(element => element.length);
    if (questionData.length > 0 && questionData[questionData.length - 1][0].questionSet !== questionData.length) {
      questionData.forEach((set: IQuestion[], index: number) => {
        set.forEach((question: IQuestion) => {
          question.questionSet = index + 1;
        });
      });
    }
    questionData.forEach((questionSet: IQuestion[]) => {
      questionSet.forEach(question => question.controlName = question.name.split(/[\s-]+/).map(el => el.toLowerCase()).join('-'));
    });
    return questionData;
  }
}
